import { newsFlash } from "@/mocks/newsFlash";

export default function TopStrip() {
  const items = newsFlash.map((item) => item.title);

  return (
    <div className="w-full overflow-hidden bg-foreground-950 text-background-50">
      <div className="mx-auto flex h-8 max-w-7xl items-center gap-3 px-4 md:px-6">
        <span className="hidden shrink-0 items-center gap-2 text-xs font-medium tracking-wide text-secondary-300 sm:flex">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-flashlight-fill text-secondary-300" />
          </span>
          最新更新
        </span>
        <div className="marquee-mask relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center">
            {[0, 1].map((loop) => (
              <div key={loop} className="flex items-center" aria-hidden={loop === 1}>
                {items.map((text, index) => (
                  <span
                    key={`${loop}-${index}`}
                    className="flex items-center whitespace-nowrap text-xs text-background-100/90"
                  >
                    <i className="ri-checkbox-blank-circle-fill mr-3 text-[5px] text-primary-400" />
                    {text}
                    <span className="mx-6 h-3 w-px bg-background-50/20" />
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 text-xs text-background-100/70 md:block">
          每周三 / 周六 定时开箱
        </span>
      </div>
    </div>
  );
}